import React, { Suspense, useEffect } from 'react';
import { bool, number, object } from 'prop-types';
import { sendMixPanelEvent } from '../../utils/biEvents';
import { MP_SHOW_PAGE_NAME } from '../../utils/biEvents/events/mixPanelEvents';
import { MIXPANEL_EVENT_TYPES } from '../../utils/types/mixpanelEventTypes';
import shouldShowLogoMakerBanner from '../../utils/shouldShowLogoMakerBanner';
import { lazyImport } from '../../utils/lazyImport';
import Hero from '../../components/Hero';
import TrustedBy from '../../components/TrustedBy';
import Seo from '../../components/Seo';
import InspiredByRecentViews from '../../components/InspiredByRecentViews';
import SubcategoryCarousel from '../../components/SubcategoryCarousel';
import SellingProposition from '../../components/SellingProposition';
import Categories from '../../components/Categories';
import { LAZY_COMPONENTS } from './constants';

import './style.scss';

const MadeOnFiverr = lazyImport(
    LAZY_COMPONENTS.MADE_ON_FIVERR,
    () => import(/* webpackChunkName: 'MadeOnFiverr' */'../../components/MadeOnFiverr')
);
const Testimonials = lazyImport(
    LAZY_COMPONENTS.TESTIMONIALS,
    () => import(/* webpackChunkName: 'Testimonials' */'../../components/Testimonials')
);
const FibBanner = lazyImport(
    LAZY_COMPONENTS.FIB_BANNER,
    () => import(/* webpackChunkName: 'FibBanner' */'../../components/FibBanner')
);
const FiverrGuides = lazyImport(
    LAZY_COMPONENTS.FIVERR_GUIDES,
    () => import(/* webpackChunkName: 'FiverrGuides' */'../../components/FiverrGuides')
);
const Signup = lazyImport(
    LAZY_COMPONENTS.SIGNUP,
    () => import(/* webpackChunkName: 'Signup' */'../../components/Signup')
);
const LogoMakerBanner = lazyImport(
    LAZY_COMPONENTS.LOGO_MAKER_BANNER,
    () => import(/* webpackChunkName: 'LogoMakerBanner' */'../../components/LogoMakerBanner')
);

const LoggedOutHomepageClient = ({
    currency,
    lastGigInCookie,
    userWasLoggedIn,
    heroBgIndex
}) => {
    useEffect(() => {

        sendMixPanelEvent({
            eventName: MP_SHOW_PAGE_NAME,
            eventType: MIXPANEL_EVENT_TYPES.PAGE_VIEW
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const showLogoMakerBanner = shouldShowLogoMakerBanner();

    return (
        <div className="logged-out-homepage">
            <Seo/>
            <Hero bgIndex={heroBgIndex}/>
            <TrustedBy/>
            <div className="max-width-container">
                <InspiredByRecentViews currency={currency}
                    lastGigInCookie={lastGigInCookie}
                    userWasLoggedIn={userWasLoggedIn}/>
                <SubcategoryCarousel/>
            </div>
            <SellingProposition/>
            <Categories/>
            <Suspense fallback={<div/>}>
                <FibBanner/>
                <Testimonials/>
                {showLogoMakerBanner && <LogoMakerBanner/>}
                <MadeOnFiverr/>
            </Suspense>
            <div className="max-width-container">
                <Suspense fallback={<div/>}>
                    <FiverrGuides/>
                    <Signup/>
                </Suspense>
            </div>
        </div>
    );
};

LoggedOutHomepageClient.propTypes = {
    currency: object,
    lastGigInCookie: number,
    userWasLoggedIn: bool,
    heroBgIndex: number
};

export default LoggedOutHomepageClient;
